<template>
	<a class="btn" :title="item.title" @click="click($event)">
		<i class="fa" v-bind:class="getIcon()"></i>&nbsp;{{getLable()}}
	</a>
</template>

<script>
	export default {
		props: ['item', 'ischecked'],
		methods: {
			click: function (e) {
				this.$emit('changechecked', this.ischecked);
			},
			getIcon: function () {
				if (!this.item.icon) {
					return { 'fa-toggle-on': this.ischecked, 'fa-toggle-off': !this.ischecked }
				} else if (typeof this.item.icon == "string") {
					var icon = this.item.icon
					//console.log(icon)
					return { icon: this.ischecked }
				} else if (typeof this.item.icon == "object") {
					var icon = this.item.icon
					var icon0 = icon[0]
					var icon1 = icon[1]
					//console.log(icon)
					var iconObj = new Object();
					iconObj[icon0] = this.ischecked
					iconObj[icon1] = !this.ischecked
					return iconObj
				}
			},
			getLable: function () {
				//console.log(this.item)
				if (typeof this.item.value == "string") { return this.item.value }
				if (this.ischecked) {
					return this.item.value[0]
				} else {
					return this.item.value[1]
				}
			}
		}
	}

</script>

<style>

</style>


// WEBPACK FOOTER //
// radio.vue?8462b982